export const coreConstants = {
    GET_CORE_ISSUERS_REQUEST: "GET_CORE_ISSUERS_REQUEST",
    GET_CORE_ISSUERS_SUCCESS: "GET_CORE_ISSUERS_SUCCESS",
    GET_CORE_ISSUERS_FAILURE: "GET_CORE_ISSUERS_FAILURE",
    GET_CORE_ISSUERS_RESET: "GET_CORE_ISSUERS_RESET",

    GET_CORE_DOMAINS_REQUEST: "GET_CORE_DOMAINS_REQUEST",
    GET_CORE_DOMAINS_SUCCESS: "GET_CORE_DOMAINS_SUCCESS",
    GET_CORE_DOMAINS_FAILURE: "GET_CORE_DOMAINS_FAILURE",
    GET_CORE_DOMAINS_RESET: "GET_CORE_DOMAINS_RESET",

    GET_CORE_CURRENCIES_REQUEST: "GET_CORE_CURRENCIES_REQUEST",
    GET_CORE_CURRENCIES_SUCCESS: "GET_CORE_CURRENCIES_SUCCESS",
    GET_CORE_CURRENCIES_FAILURE: "GET_CORE_CURRENCIES_FAILURE",
    GET_CORE_CURRENCIES_RESET: "GET_CORE_CURRENCIES_RESET",
  
    
  };
  